import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedDftypeReducer(state = initialState.selectedDftypes, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_DFTYPES_SUCCESS:
      return action.selectedDftypes;
    default:
      return state;
  }
}
